import { type Actions, ActionType } from './branding.actions';
import { initialState, type State } from './branding.state';

export function brandingReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_BRANDING:
            return {
                ...state,
                isPending: true
            };

        case ActionType.FETCH_BRANDING_SUCCEEDED:
            return {
                ...state,
                branding: action.payload.branding,
                isPending: false,
                isLoaded: true
            };

        case ActionType.FETCH_BRANDING_FAILED:
            return {
                ...state,
                isPending: false,
                isLoaded: false
            };

        default:
            return state;
    }
}
